import { appEnv } from 'shiver-core/env';

/**
 * 現在の環境に基づいて、shiver-appのベースURLを取得する
 */
export function getAppBaseUrl(): string {
  switch (appEnv) {
    case 'prod':
      return 'https://code.shojihomu.jp';
    case 'stage':
      return 'https://code-stage.shojihomu.jp';
    case 'dev':
      return 'https://code-dev.shojihomu.jp';
    case 'local':
    default:
      return 'http://localhost:3344';
  }
}
